export const settings = {
  apiKey: 'b6897e02-c132-48e7-8563-7f12193d6351',
  lang: 'ru_RU',
  coordorder: 'latlong',
  version: '2.1',
}
